import React from "react";
import {Dropdown} from "primereact/dropdown";

const PresvalDropDown = (props) => {
    return (
        <React.Fragment>
            <Dropdown
                name={props.name}
                filterBy={props.filter}
                options={props.options}
                optionLabel={props.filter}
                placeholder={props.placeholder ? props.placeholder : "Seleccione..."}
                onChange={props.save}
                value={props.value}
                disabled={props.disabled}
                tabIndex={props.tabIndex ? props.tabIndex : ''}
            />
        </React.Fragment>
    )
};

export default PresvalDropDown;